import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { getAdjustmentList } from '@store/Finance/FixedAssets/FaAdjustment/FaAdjustmentSlice';
// import { useTranslation } from 'react-i18next';

const useGetFaAdjustmentList = () => {
  const dispatch = useAppDispatch();
  // const { t, i18n } = useTranslation();

  useEffect(() => {
    // if (AssetsList?.length === 0) {
    dispatch(getAdjustmentList());
    // }
  }, []);
  const { AdjustmentList, loading, error } = useAppSelector(state => state.FaAdjustment);

  // var OptionsAssets = Retirement?.map(({ id, name, name2 }) => ({
  //   value: id,
  //   label: `${i18n.language === 'en' ? name : name2}`,
  // }));

  return { AdjustmentList, loading, error };
};

export default useGetFaAdjustmentList;
